import { Facet } from "@linkfluence/models/facet";
import { useSearchFragmentData } from "@radarly/core/fragment/use-cases";
import { getInnerClauseFromClause } from "@radarly/models/clause/getter";
import { Post } from "@radarly/models/posts";
import { SearchFragment } from "@radarly/models/search";

function getCleanFragment(fragment: SearchFragment) {
  if (!fragment) return null;
  const cleanQuery = getInnerClauseFromClause(
    fragment.request.query,
    Facet.Query
  );
  return {
    ...fragment,
    request: {
      ...fragment.request,
      query: { and: [cleanQuery] },
    },
  };
}

export function usePinnedPostWidget(
  project: number,
  fragment: SearchFragment
): { post: Post; loading: boolean; isError: boolean } {
  const cleanFragment = getCleanFragment(fragment);
  const { loading, data, isError } = useSearchFragmentData(
    project,
    cleanFragment
  );
  const post = data?.hits?.[0];
  return {
    post,
    loading,
    isError: isError || (fragment && !loading && !post),
  };
}
